// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_blueprintjs_popover2_lib_esm_popover2_js-node_modules_blueprintjs_popove-892e47"], () => (__webpack_require__("./src/client/app.jsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
